import React, { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
  {
    src: 'https://s3-ap-southeast-1.amazonaws.com/tz-mag-ph/wp-content/uploads/2017/07/11110051/Boracay-Featured.jpg',
    altText: 'Slide 1',
    caption: 'Zuitt Team Boracay Escaped'
  },
  {
    src: 'https://static.tripzilla.com/thumb/0/5/77061_960x631.jpg',
    altText: 'Slide 2'
  },
  {
    src: 'https://sgp1.digitaloceanspaces.com/tz-mag-ph/wp-content/uploads/2018/04/070704045959/cris-tagupa-566759-unsplash-770x578.jpg',
    altText: 'Slide 3'
  }
];

const ToursCarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
        className="animated fadeIn slower"
      >
        <img src={item.src} alt={item.altText} height="450" width="800" className="rounded" />
        <CarouselCaption className="text-dark" captionHeader={item.caption} />
      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  );
}

export default ToursCarousel;